<template>
    <div class="list-raovat position-relative">
       <div class="fw-600 title-product-keyword">
            Tham gia đấu giá từ khóa sản phẩm {{title}}
            <div class="note">
                Đưa sản phẩm lên vị trí bạn mong muốn, tăng gấp đôi doanh số.
            </div>
       </div>
       <div class="search_input action-table-web position-relative">
           <label class="fw-600 fs-14px">Vatgia gợi ý từ khóa cần đấu giá theo tiêu đề sản phẩm</label>
           <div :class="{ 'search position-relative' : true, 'mobile-search' : $detect == 'mobile' }">
                <input type="text" name="" value="" placeholder="Tìm kiếm từ khóa...." 
                    v-model="keyword" 
                    @focus="focusInput" 
                    @blur="blurInput" 
                    @input="search()"
                    class="w-100">
                <div class="btn-search position-absolute">
                    <span class="lable-search px-10px">
                        <i class="icon ion-ios-search fs-20px"></i>
                    </span>
                </div>
                <span class="add_keyword_estore" v-if="keyword != '' && $detect == 'web'" @click="addKeyword">Thêm từ khóa</span>
                <span class="add_keyword_estore" v-if="keyword != ''&& $detect == 'mobile'" @click="addKeyword"><i class="icon ion-ios-add fs-20px"></i></span>
           </div>
           <ul :class="{
                        'box-suggest position-absolute' : true,
                        'box-suggest-mobile' : $detect == 'mobile'
                    }" v-if="showSuggest && searchKeyword.length > 0">
               <li v-for="(item, key) in searchKeyword" :key="key" @click.self="pushKeyword(item)">
                    {{ item.keyword }}
                   <div class="price-k">
                       Giá cao nhất: <span class="price">{{ $formatNumber(item.top_price) }}₫</span>
                   </div>
               </li>
           </ul>
           
       </div>
       <div class="search_input_suggest">
           <span v-for="(value,key) in suggest" :key="key" :class="{'active' : sosanh(value.iKey) }" @click="slectKeyword(value)">{{ value.keyword }} </span>
       </div>
        <!-- table list rao vặt -->
        <table :class="{
                'table': true,
                'table-borderless': $detect == 'web'
            }">
            <!-- thead web -->
            <thead v-if="$detect == 'web'">
                <tr>
                    <th scope="col" class="text-center">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input"
                                id="select-all-table" v-model="selectAll"/>
                            <label class="custom-control-label" for="select-all-table"></label>
                        </div>
                    </th>
                    <th scope="col" class="text-center">Từ khóa</th>
                    <th scope="col">Giá</th>
                    <th scope="col">Giá đặt</th>
                    <th scope="col" class="text-center">Thời gian</th>
                    <th scope="col" class="text-center">Thiết lập tối đa</th>
                    <th scope="col" class="text-center">Đã tiêu</th>
                    <th scope="col" class="text-center">Gia hạn</th>
                    <th scope="col" class="text-center">Xóa</th>

                </tr>
            </thead>
            <!-- hết thead web -->

            <!-- thead mobile -->
            <thead v-else>
                <tr>
                    <th scope="col" class="text-center py-1">
                        <span class="check-all-mobile" @click="selectAll = !selectAll">
                            <img :src="selectAll ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                        </span>
                    </th>
                    <th scope="col" class="text-center py-1">Thông tin</th>
                </tr>
            </thead>
            <!-- hết thead mobile -->

            <!-- tbody -->

            <!-- check xem có dữliệu hay không -->
            <tbody v-if="product.length == 0">
                <tr>
                    <td colspan="8" class="text-center text-muted">Không có dữ liệu {{product.length}}</td>
                </tr>
            </tbody>

            <!-- có dữ liệu -->
            <!-- tbody web -->
            <tbody v-else-if="$detect == 'web'" class="product">
                <tr :class="{
                        'position-relative': true,
                        'pending': item.status != 1 || item.status == 1 && item.status_expire === 0
                    }" v-for="(item,index) in product" :key="index">
                    <!-- td checkbox -->
                    <td scope="row" style="white-space: nowrap;">
                        <div class="custom-control custom-checkbox text-center"
                           >

                            <input type="checkbox" class="custom-control-input"
                                :id="item.iKey" :value="item.iKey" v-model="idSelect"/>
                            <label class="custom-control-label" :for="item.iKey"></label>
                        </div>
                    </td>
                    <!-- keyword -->
                    <td width="250" class="position-relative">
                        {{item.kep_keyword}}
                        <div :class="{
                                    'position-absolute w-100 h-100 t_s' : true,
                                    'status'  : item.status == 1,
                                    'waiting'  : item.status == 4
                                }">
                            {{ item.status_text }}
                        </div>
                    </td>
                    <!-- td tiêu đề, id, link -->
                    <td class="hit-rv" width="100">
                        <div class="text-center">
                           {{ $formatNumber(product[index].price) }}₫
                        </div>
                    </td>
                    <!-- td lượt xem -->
                    <td class="hit-rv" width="100">
                        <select v-model="product[index].price" class="text-center">
                            <option disabled value="" class="text-center">Chọn</option>
                            <option v-for="(item, key) in arrPrice" :key="key" :value="item" class="text-center">{{ $formatNumber(item) }}₫</option>
                        </select>
                    </td>
                    <!-- td ngày update -->
                    <td width="140" class="text-center keyword-sale">
                        <div :class="{'d-flex' : true, 'justify-content-between' : $detect == 'mobile', 'mb-1' : true}">
                            <div :class="{
                                    'fw-600' : true,
                                    'mr-1'   : $detect == 'web',
                                    'set-width' : true
                                }">
                                Từ: 
                            </div>
                            <div :class="{
                                    'fw-600' : true,
                                    'mr-1'   : $detect == 'web'
                                }">
                              <input type="date" class="date-change"  v-model="product[index].start_date"
                                   />
                            </div>
                            <div>
                                <ldc-time placeholder="HH:mm"
                                    :showSeconds="false"
                                    :jumpMinutes="5"
                                    titleMobile="Thời gian"
                                    v-model="product[index].start_time"
                                    class="time-change"/>
                            </div>
                        </div>
                        <div :class="{'d-flex' : true, 'justify-content-between' : $detect == 'mobile'}">
                            <div :class="{
                                    'fw-600' : true,
                                    'mr-1'   : $detect == 'web',
                                    'set-width' : true
                                }">
                                Đến : 
                            </div>
                            <div :class="{
                                    'fw-600' : true,
                                    'mr-1'   : $detect == 'web'
                                }">
                              <input type="date" class="date-change" v-model="product[index].end_date"
                                   />
                            </div>
                            <div>
                                <ldc-time placeholder="HH:mm"
                                    :showSeconds="false"
                                    :jumpMinutes="5"
                                    titleMobile="Thời gian"
                                    v-model="product[index].end_time"
                                    class="time-change"/>
                            </div>
                        </div>
                    </td>
                    <td width="120" class="text-center">
                       <input type="text" inputmode="numeric" class="input-price-up input-price-up-web ml-1" v-model="product[index].max_amount" @input="calculateTotal(index)" @focus="(e) => e.target.select()"/>
                    </td>
                    <td width="150" class="text-center">
                        {{ $formatNumber(product[index].spent) }}₫
                    </td>
                    <td width="150" class="text-center">
                         <input type="checkbox" class="custom-control-input"
                            :id="item.id" :value="item.id" v-model="auto"/>
                        <label class="custom-control-label auto-custom" :for="item.id"></label>
                    </td>
                    <td width="150" class="text-center">
                        <button type="button" class="btn btn-danger btn-sm px-3"
                            @click="destroy(item)">
                            <i class="icon ion-md-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
            <!-- hết tbody web -->

            <!-- tbody mobile -->
            <tbody v-else>
                <tr :class="{
                        'table-mobile position-relative': true,
                    }" v-for="(item, index) in product" :key="index">
                    <!-- td ảnh và checkbox -->
                    <td class="img-tab position-relative pl-1">
                        <div class="checkbox-mobile position-absolute">
                            <input type="checkbox" class="d-none" v-model="idSelect"
                                :value="item.iKey" :id="item.iKey"/>
                            <label class="checkbox-label" :for="item.iKey">
                                <img :src="idSelect.includes(item.iKey) ? $urlImage('/images/selected.svg') : $urlImage('/images/unselect.svg')"/>
                            </label>
                        </div>
                    </td>
                    <!-- td thông tin -->
                    <!-- click thông tin là show model xử lý -->
                    <!-- <td style="width: calc(100% - 100px)" @click="actionItem(item)"> -->
                    <td   class="position-relative d-flex"
                        @click="activeTr = index">
                        <div class="name fw-600">{{item.kep_keyword}}</div>
                        <div :class="{
                                'end-start text-center' : true, 
                                'status'  : item.status == 1,
                                'waiting'  : item.status == 4
                                }">{{item.status_text}}</div>
                        <div class="action-k text-right">
                            <button class="btn-edit btn-sm mr-1 btn" @click="detail(index,item)"><i class="icon ion-md-create"></i></button>
                            <button type="button" class="btn btn-danger btn-sm "
                            @click="destroy(item)">
                            <i class="icon ion-md-trash"></i>
                        </button>
                        </div>

                    </td>
                </tr>
            </tbody>
            <!-- hết tbody mobile -->
        </table>
        <div class="d-flex">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Tài khoản có:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'ml-3': $detect == 'mobile'
            }">
                <span class="mb-0"><span class="text-danger fw-600">{{money.money_text}}</span> {{money.unit}}</span>
                <span class="ml-3"><a href="https://vatgia.com/nap-tien.html" class="btn-recharge">Nạp {{money.unit}}</a></span>
            </div>
        </div>
        <div class="d-flex">
            <div :class="{
                    'fw-600 fs-14px': true,
                    'w-30': $detect == 'web'
                }">Số tiền đã bị trừ:</div>
            <div :class="{
                'w-70': $detect == 'web',
                'ml-3': $detect == 'mobile'
            }">
                <span class="mb-0"><span class="text-danger fw-600">{{ $formatNumber(totalSpent) }}</span> {{money.unit}}</span>
            </div>
        </div>
        <div class="mt-5 mt-mobile d-flex product-keyword">
            <div class="btn-confirm mb-3">
                <button class="btn btn-primary mx-auto py-1" @click="submitPpcKeyword">Thực hiện</button>
            </div>
        </div>
        <transition name="slide-fade">
            <detailKeywordSale v-if="show" 
                    :data.sync="product[index]"
                    :arrPrice="arrPrice" 
                    :show.sync="show">
            </detailKeywordSale>
        </transition>
    </div>
</template>
<script>
import { upTop, availability, destroy } from '@/config/product';
export default {
    components: {
        paginate: () => import('@/components/layout/pagination.vue'),
        actionTable: () => import('./fillter.vue'),
        detailKeywordSale: () => import('@/components/profile/product/detailKeywordSale.vue'),
    },
    data(){
        return {
            product: [], // data sản phẩm
            idSelect: [], // id rao vặt select để sử lý muti
           
            selectAll: false, // trạng thái có select all hay không
            loading: '', // loading theo tr
            loadingAction: '', // loading theo xử lý

            auto: [],
            selectPrice : [],
            title: '',
            suggest : [],
            arrKey  : [],
            arrPrice : [],
            totalSpent : 0,
            keyword : '',
            timeOutStatus: null,
            id : this.$route.query.id,
            searchKeyword : [],
            showSuggest : false,
            dayNow : '',
            show : false,
            index: '',
            messageError : '',

        }
    },
    created() {
        this.$store.state.title = 'Đấu giá từ khóa';
        let day = new Date();
        let dayNow = day.getDate() < 10 ? '0'+day.getDate() : day.getDate();
        let m = day.getMonth() + 1 < 10 ? '0'+(day.getMonth()+1) : day.getMonth() + 1;
        this.dayNow = day.getFullYear() + '-' + m + '-' + dayNow;
        this.getData();
    },
    methods: {
       async getData(){
            await apiGet('/v2/products/get_proudct_keyword_sale', {id : this.$route.query.id}).then(res => {
                this.title = res.data.title;
                this.suggest = res.data.arrSuggestKeyword;
                this.arrKey = res.data.arrKey;
                this.arrPrice = res.data.arrPrice;
                this.totalSpent = res.data.totalSpent;
                this.product = res.data.arrKeywordPPC;
                this.selectAll = false;
                this.product.map((item, index) => {
                    if(item.status == 1 || item.status == 4){
                        this.idSelect.push(item.iKey);
                    }
                })
            }).catch(err => {
                if(err.status == 410){
                    this.$message({
                        message: err.data.message,
                        type: 'warning',
                        center: true,
                    });
                    this.$router.push({
                        name: 'product',
                        query: ''
                    })
                }
            });
        },
        addKeyword(){
            apiPost('v2/products/add_keyword_estore', {
                    keyword: this.keyword,
                    iPro    : this.id,
                }).then(res => {
                    this.pushKeyword(res.data)
                });
        },
        detail(key,item){
            this.show = !this.show;
            this.index = key;
            this.pushId(item);
        },
        slectKeyword(value){
            this.pushIdMuti(value);
            this.arrKey.push(value.iKey);
            let check = false;
            this.product.map((item, index) => {
                if(item.iKey === value.iKey){
                    check = true;
                }
            })
            if(!check){
                this.product.push({
                    iKey : value.iKey,
                    checksum : value.checksum,
                    max_amount : 20000,
                    price : 1000,
                    spent : 0,
                    status : null,
                    status_text : '',
                    kep_keyword : value.keyword,
                    end_time : '22:00',
                    end_date: this.dayNow,
                    start_time: '08:00',
                    start_date: this.dayNow,
                    active : true,
                    auto_extend  : false,
                })
            }
        },
        pushKeyword(value){
            let check = false;
            this.pushIdMuti(value);
            this.arrKey.push(value.iKey);
            this.product.map((item, index) => {
                if(item.iKey === value.iKey){
                    check = true;
                }
            })
            if(!check){
                this.product.push({
                    iKey : value.iKey,
                    checksum : value.checksum,
                    max_amount : 20000,
                    price : 1000,
                    spent : 0,
                    status : null,
                    status_text : '',
                    kep_keyword : value.keyword,
                    end_time : '22:00',
                    end_date: this.dayNow,
                    start_time: '08:00',
                    start_date: this.dayNow,
                    active : true,
                    auto_extend  :false,
                })
            }
            let yourObject = {};
            yourObject[value.iKey] = {
                checksum : value.checksum,
                iKey : value.iKey,
                keyword : value.keyword,
                top_price : value.top_price,
                kpt_id : value.iKey,
                kpt_keyword : value.keyword
            }
            this.suggest = Object.assign(this.suggest, yourObject);
        },
        async focusInput(e) {
            // this.showDropdown = true;
            this.showSuggest = true;
            if(this.keyword && this.keyword.length >= 3){
                await this.getSearch(this.keyword);
            }
        },
        blurInput(e){
            setTimeout(() => {
               this.showSuggest = false;
            }, 100);

        },
        search(){
            if(this.keyword.length >= 3){
                this.vloading = true;
                if(this.timeOutStatus) clearTimeout(this.timeOutStatus);
                this.timeOutStatus = setTimeout(() => {
                    this.getSearch(this.keyword);
                }, 300);
            }else if(this.keyword.length == 0){
                // this.status_category = 1;
            }
        },
        async getSearch(keyword = null) {
            if(keyword && keyword.length > 3){
                this.vloading = true;
                await apiGet('/v2/products/action_keyword_ppc', {
                    keyword: keyword ? keyword : this.keyword,
                    iPro    : this.id,
                    action : 'suggest'
                }).then(res => {
                    this.searchKeyword = res.data;
                });
                this.vloading = false;
            }
        },
        calculateTotal(key){
            this.product[key].max_amount = formatNumber(this.product[key].max_amount);
        },
        sosanh(id){
            var check = false;
            this.arrKey.map((item, index) => {
                if(item === id){
                    check = true;
                }
            })
            return check;
        },
        async submitPpcKeyword(){
            let form = [];
            let checksum = "";
            this.messageError = "";
            this.product.map((item,index) => {
                if(this.idSelect.includes(item.iKey)){
                    if(item.checksum){
                        checksum = item.checksum;
                    }else{
                        checksum = this.suggest[item.iKey].checksum;
                    }
                    form.push({
                        iEst        : item.color,
                        iPro        : this.id,
                        iKey        : item.iKey,
                        keyword     : item.kep_keyword,
                        start_time  : item.start_time,
                        start_date  : item.start_date,
                        end_time    : item.end_time,
                        end_date    : item.end_date,
                        price       : item.price,
                        max_amount  : this.$stringToNumber(item.max_amount),
                        auto_extend : item.auto_extend,
                        active      : item.active,
                        checksum    : checksum
                    });
                    this.checkform(item)
                }
            })

            if(form.length > 0){
                if(this.messageError != ''){
                    this.$message({
                        message: this.messageError,
                        type: 'warning',
                        center: true,
                    });
                }else{
                     await apiPost('/v2/products/add_keyword_estore_ppc', {form}).then(res => {
                        if(res.success == 1){
                            this.$message({
                                message: res.message,
                                type: 'success',
                                center: true,
                            });
                            this.getData();
                           
                        }else{
                           console.log(res.data.message);
                        }
                    }).catch(err => {
                        if(err.status == 410){
                            this.$message({
                                message: err.data.message,
                                type: 'warning',
                                center: true,
                            });
                        }
                    });
                }
            }else{
                this.$message({
                    message: 'Bạn chưa chọn từ khóa tham gia đấu giá!',
                    type: 'warning',
                    center: true,
                });
            }
            console.log(form)
        },
        checkform(item){
            if(parseInt(this.dayNow.replace(/-/g,""),10) > parseInt(item.start_date.replace(/-/g,""),10)){
                this.messageError += 'Từ khóa "<span class="fw-600">' +item.kep_keyword + '</span>": Thiết lập sai thời gian! </br>';
            }else{
                if(parseInt(item.end_date.replace(/-/g,""),10) < parseInt(item.start_date.replace(/-/g,""),10)){
                    this.messageError += 'Từ khóa "<span class="fw-600">' +item.kep_keyword + '</span>": Thiết lập sai thời gian!</br>';
                }
            }
            if(this.$stringToNumber(item.max_amount) < item.price){
                this.messageError += 'Từ khóa "<span class="fw-600">' +item.kep_keyword + '</span>": Tiền thiết lập tối đa phải lớn hơn giá đặt!';
            }
        },
        pushIdMuti(item){
            if(this.idSelect.includes(item.iKey)){
                let index = this.idSelect.indexOf(item.iKey);
                this.idSelect.splice(index, 1);
            }else{
                this.idSelect.push(item.iKey);
            }
        },
        pushId(item){
            if(!this.idSelect.includes(item.iKey)){
                this.idSelect.push(item.iKey);
            }
        },
        destroy(item){
            this.$confirm('Bạn có chắc chắn xóa từ khóa "'+ item.kep_keyword +'" này?', 'Xóa từ khóa', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'error'
            }).then(async res => {

                await apiPost('/v2/products/delete_keyword_estore_ppc', {
                    iPro : this.id,
                    iKey : item.iKey
                }).then(res => {
                    this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                    this.getData();
                }).catch(err => {
                    if(err.status == 410){
                        // this.error = err.data.message;
                        this.$message({
                            message: err.data.message,
                            type: 'warning',
                            center: true,
                        });
                    }
                });
            }).catch(() => {})
        },
    },
    watch: {
        query:{
            handler(val){
                apiGet('/v2/profile/products', {
                    category: val.category ? val.category*1 : '',
                    fillter: val.fillter ? val.fillter*1 : '',
                    keyword: val.keyword,
                    page: val.page ? val.page*1 : '',
                }).then(res => {
                    this.preview = res.data.array_product_count;
                    let data = res.data.db_listing;
                    this.product = data.data;
                    this.last_page = data.last_page;
                    this.next_page = data.next_page;
                    this.current_page = data.current_page;
                    this.selectAll = false;
                });
            },
            deep: true
        },
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.product.map(item => {
                    this.idSelect.push(item.iKey);
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.product.map(item => {
                    if(item.status == 1 && item.status_expire == 1){
                        count += 1;
                    }
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
        showModel(val){
            if(!val){
                this.dataActionItem = {};
            }
        }
    },
    computed: {
        widthTable(){
            let table = document.querySelector('table');
            return table.clientWidth;
        },
        query(){
            return this.$route.query;
        },
        money(){
            return this.$store.state.money;
        },
      
    },

}
</script>
<style lang='scss'>
    .keyword-sale{
        .date-change{
            height: 35px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            color: #606266;
            outline: none;
            cursor: pointer;
            width: 135px;
        }   
        .ldc-time .ldc-dropdown input {
            width: 75px;
        }
        .set-width{
            width : 35px;
            line-height: 35px;
        }
        
    }
    .product-keyword{
        .btn-confirm{
            margin: 0 auto;
        }
    }

    .product {
        .input-price-up{
            &.input-price-up-web{
                width: 60px !important;
            }
            border: none;
            border-bottom: 1px solid #000;
            width: 75px;
            border-radius: 0 !important;
            color: #dc3545;
            font-weight: 600;
        }
        .t_s{
            font-size: 10px; 
            left: 12px; 
            background: #f6f6f65c;
            color: red;
        }
        .status{
            color: green;
        }
        .waiting{
            color: #ffc107;
        }
        .auto-custom::before{
            left: -0.5rem;
        }
        .auto-custom::after{
            left: -0.5rem;
        }

    }
    .table-mobile {
        .btn-edit{
            border: none;
            background: #f1c40f;
            padding: 0.313rem 0.5rem;
            font-size: .875rem;
            line-height: 1.5;
            border-radius: .2rem;
            i{
                color: white;
            }
        }
        .name{
            width: 40%;
            line-height: 42px;
        }
        .end-start{
            width: 36%;
            color: red;
            line-height: 42px;
            &.status{
                color: green;
            }
            &.waiting{
                color: #ffc107;
            }
        }
        .action-k{
            width: 24%;
            line-height: 42px;

        }
    }
    .title-product-keyword{
        color: #333333;
        font-size: 18px;
        margin: 10px 0;
        border-bottom: 1px solid #d7d7d7;
        padding-bottom: 15px;
        .icon_sprite{
            background-position: -4px -3211px;
            height: 28px;
            width: 27px;
            background: url('https://vatgia.com/css/v4/beacon_sprite.png') no-repeat;
            display: inline-block;
            vertical-align: middle;
        }
         .note{
            font-size: 12px;
            color: #999;
            font-weight: normal;
            margin-top: 1px;
        }
    }
    .search_input{
        .search{
            width: 372px;
            &.mobile-search{
                width: 317px!important;
                .add_keyword_estore{
                    padding: 0;
                    line-height: 35px;
                    margin-left: 7px;
                    width: 35px;
                    left: unset;
                }
            }
            .add_keyword_estore{
                background: #1786cd;
                color: white;
                font-size: 13px;
                padding: 7px 10px;
                border-radius: 4px;
                cursor: pointer;
                text-align: center;
                position: absolute;
                top: 3px;
                height: 35px;
                left: 390px;
                width: 105px;
                position: absolute;
                top: 0;
            }
        }
    }
    .search_input_suggest{
        span{
            cursor: pointer;
            background: #eaf3f8;
            color: #a5b9c2;
            font-size: 12px;
            border: 1px solid #a5b9c2;
            padding: 0 10px;
            display: inline-block;
            margin-right: 10px;
            height: 25px;
            line-height: 25px;
            border-radius: 3px;
            box-sizing: border-box;
            margin-bottom: 5px;
            &.active{
                color: white;
                background: #1786cd;
                border-color: #1786cd;
            }
        }
    }
    .hit-rv{
        select{
            height: 35px;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            color: #606266;
            outline: none;
            cursor: pointer;
            width: 75px;
            option{
                width: 75px;
            }
        }
    }
    .box-suggest{
        &.box-suggest-mobile{
            width : 317px!important;
        }
        width: 372px;
        border-right: 1px solid #d7d7d7;
        border-left: 1px solid #d7d7d7;
        background: white;
        box-sizing: border-box;
        z-index : 12;
        li{
            border-bottom: 1px solid #d7d7d7;
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            cursor: pointer;
            .price-k{
                font-size: 13px;
                float : right;
                .price{
                    color: #f44f00;
                }
            }
        }
    }
    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to{
        transform: translateX(10px);
        opacity: 0;
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .search_input{
            .search{
                &.mobile-search {
                    width: 265px !important;
                }
            }
        }
        .table-mobile .end-start {
            line-height: 130%!important;
            justify-content: center;
            align-items: center;
            display: flex;
        }
    }
</style>
